
export const VocabAddresses = {
    'addresses': ['Direcciones', 'Addresses'],
    'address': ['Direccion', 'Address'],
    'state' : ['Estado', 'State'],
    'street': ['Calle', 'Street'],
    'number': ['Numero', 'Number'],
    'interior_number': ['Numero interior', 'Interior number'],
    'zip_code': ['Codigo postal', 'ZIP Code'],
    'city': ['Ciudad', 'City'],
    'country': ['Pais', 'Country'],
    'google_maps_url': ['Google Maps URL', 'Google Maps URL'],
    'add_address': ['Añadir direccion', 'Add address'],
    'remove_address': ['Eliminar direccion', 'Remove address'],
    'save_changes': ['Guardar cambios', 'Save changes'],
    
  }
    